import { styled } from '@nykaa/ui-components';

export const Info = styled.span<{ isOutOfStock?: boolean; }>`
  ${({ theme }) => theme.typography.bodyXSmall};
  color: ${({ theme, isOutOfStock }) =>
    isOutOfStock ? theme.colors.textSecondary : theme.colors.warningPrimary};
  align-self: center;
  margin-top: ${({ theme }) => theme.spacing.spacing20};
`;
